import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';

interface ToolsDetailsPartProps {
  partId: number | null;
}

const ToolsDetailsPartComponent: FC<ToolsDetailsPartProps> = ({
  clearTools,
  getNCFileByPartId,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
  partId,
}) => {
  const title = useTitle();

  const { partDataLoading } = usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      <PartListOrSingleItem partDataLoadingForList={partDataLoading} partId={partId} />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsPart = connect(({ details: { partId } }) => ({ partId }), {
  clearTools,
  getNCFileByPartId,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(ToolsDetailsPartComponent);

export { ToolsDetailsPart };
